var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102px",
    height: "102px",
    viewBox: "0 0 102 102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Apple Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AppleLogo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 102,
    height: 102
  }), /*#__PURE__*/React.createElement("g", {
    id: "apple",
    transform: "translate(11.000000, 1.000000)",
    fill: "#666666",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8549559,100 C12.157474,99.9142147 0,69.5176986 0,54.037463 C0,28.7505444 18.7236132,23.2145609 25.9395578,23.2145609 C29.1914777,23.2145609 32.6638568,24.5083747 35.7265636,25.6532857 C37.8682787,26.451929 40.0832875,27.2763665 41.3151981,27.2763665 C42.0525699,27.2763665 43.7902061,26.5750377 45.3243562,25.9596896 C48.5961424,24.6400815 52.6674072,23 57.4083438,23 C57.4168304,23 57.4282102,23 57.4365039,23 C60.9765832,23 71.7102332,23.7871141 78.1633461,33.6053263 L79.6749295,35.9066775 L77.4994607,37.5698174 C74.3916205,39.94562 68.721013,44.2794372 68.721013,52.8640221 C68.721013,63.0314332 75.1430725,66.9416001 78.2283459,68.8222321 C79.5902561,69.6523366 81,70.5082352 81,72.3802691 C81,73.6025627 71.3711541,99.8483613 57.3884773,99.8483613 C53.9670179,99.8483613 51.5485231,98.8064318 49.4152945,97.887611 C47.2567989,96.9572609 45.3947566,96.1558819 42.3179698,96.1558819 C40.7583598,96.1558819 38.7861842,96.9029367 36.698282,97.6959131 C33.8450405,98.7747753 30.6154945,100 26.951009,100 L26.8549559,100 Z",
    id: "Svgpath"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9900508,0 C59.3431612,13.3157331 50.2376625,22.5535768 41.1428244,21.9742066 C39.6441624,11.3477915 50.2365403,0 58.9900508,0 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/Apple-Logo.4ff9f81deefbc06b1a207a69d911e81a.svg";
export { ForwardRef as ReactComponent };